import { apiRequest } from "./apiService";

const toStr = (v) => String(v ?? "").trim();
const lower = (v) => toStr(v).toLowerCase();

const clampBatch = (arr, max = 50) =>
  (Array.isArray(arr) ? arr : []).filter(Boolean).slice(0, max);

/**
 * POST /events/view-session
 */
export const logViewSession = (payload = {}) => {
  const creatorId = toStr(payload.creatorId);
  if (!creatorId) {
    // Keep consistent with your API expectations
    return Promise.reject(new Error("creatorId is required"));
  }

  const platform = lower(payload.platform) || "instagram";
  const surface = lower(payload.surface) || "discover";

  const durationMs = Number.isFinite(payload.durationMs) ? Number(payload.durationMs) : 0;

  // Only include optional fields if present (keeps payload clean)
  const body = {
    creatorId,
    platform,
    surface,
    durationMs,
    unlocked: Boolean(payload.unlocked),
    ...(payload.startedAt ? { startedAt: payload.startedAt } : {}),
    ...(payload.endedAt ? { endedAt: payload.endedAt } : {}),
    ...(toStr(payload.city) ? { city: lower(payload.city) } : {}),
    ...(toStr(payload.niche) ? { niche: lower(payload.niche) } : {}),
  };

  return apiRequest("/events/view-session", "POST", body);
};

/**
 * POST /events/view-session/batch
 *
 * Backend supports:
 * - Body as list: [ {...}, {...} ]
 * - OR object with list: { items: [...] } OR { sessions: [...] } OR { events: [...] }
 *
 * We standardize on: { items: [...] }
 */
export const logViewSessionsBatch = (sessions = []) => {
  const safe = clampBatch(sessions, 50);

  const items = safe
    .map((s) => {
      const creatorId = toStr(s?.creatorId);
      if (!creatorId) return null;

      const platform = lower(s?.platform) || "instagram";
      const surface = lower(s?.surface) || "discover";

      const durationMs = Number.isFinite(s?.durationMs) ? Number(s.durationMs) : 0;

      return {
        creatorId,
        platform,
        surface,
        durationMs,
        unlocked: Boolean(s?.unlocked),
        ...(s?.startedAt ? { startedAt: s.startedAt } : {}),
        ...(s?.endedAt ? { endedAt: s.endedAt } : {}),
        ...(toStr(s?.city) ? { city: lower(s.city) } : {}),
        ...(toStr(s?.niche) ? { niche: lower(s.niche) } : {}),
      };
    })
    .filter(Boolean);

  if (!items.length) {
    return Promise.reject(new Error("No valid sessions to send (missing creatorId)."));
  }

  return apiRequest("/events/view-session/batch", "POST", { items });
};